export const getActiveTab = state => state.buttonsHeader.activeTab
